import { render, staticRenderFns } from "./CartCrossSell.vue?vue&type=template&id=dc02471e"
import script from "./CartCrossSell.vue?vue&type=script&lang=ts"
export * from "./CartCrossSell.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports